import { defineMessages } from 'react-intl';

export default defineMessages({
    carrierName: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.carrierName",
        defaultMessage: "Insurer"
    },
    carrierCountry: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.carrierCountry",
        defaultMessage: "Country"
    },
    carrierNameOther: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.carrierNameOther",
        defaultMessage: "Describe Other"
    },
    policyNumber: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.policyNumber",
        defaultMessage: "Policy Number"
    },
    riskType: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.riskType",
        defaultMessage: "Risk Type"
    },
    effectiveDate: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.effectiveDate",
        defaultMessage: "Effective Date"
    },
    expirationDate: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.expirationDate",
        defaultMessage: "Expiration Date"
    },
    isCommercial: {
        id: "policy.pa.views.pa-drivers-details.driver-policy-history.policy.isCommercial",
        defaultMessage: "Is this a Commercial Policy?"
    }
});
